import React, {useRef} from "react";
import clsx from "clsx";
import {IItemOrcamento} from "../../../types/IItemOrcamento";
import globalMU from "../../../../globalMU";
import store from "../../../redux/store/store";
const itemStyles = require('./OrdenarItens.module.scss').default

const estilosTabelas = require('../../../estilos/tabelas.module.scss').default

export type OrdenarItensProps = {
    itens: IItemOrcamento[],
    onChangeOrdem: (ordemItem:number, item: IItemOrcamento) => void
}

export const OrdenarItens = (props: OrdenarItensProps) => {
    const inputRef = useRef([React.createRef<HTMLInputElement>(), React.createRef<HTMLInputElement>()])

    const ordenarItens = (ordem: number, item: IItemOrcamento):any => {
        if (ordem > props.itens.length || ordem < 1){
            globalMU.showErrorMessage("Valor para ordem inválido !")
            return;
        }
        props.onChangeOrdem(ordem, item)
    }

    return <>
        <table className={clsx(estilosTabelas.tabela)} style={{width: "100%"}}
            id="OrdenarItens_TabelaOrdenarItens">
            <thead>
                <tr>
                    <th className={clsx(itemStyles.colunaFixa, itemStyles.colunaVazia)}></th>
                    <th className={clsx(itemStyles.colunaFixa, itemStyles.colunaOrdem)}  style={{width: "85px"}}>Ordem</th>
                    <th className={clsx(itemStyles.colunaFixa, itemStyles.colunaCodigo)}>Referência</th>
                    <th className={clsx(itemStyles.colunaFixa, itemStyles.colunaDescricao)}>Descrição</th>
                    <th>Unid.</th>
                    <th>Quant.</th>
                    <th>Preço Unitário</th>
                    <th>Preço total</th>
                </tr>
            </thead>
            <tbody>
            {
                props.itens?.map((item, key) => (
                    item.Classe?.toLowerCase() != "itempedidovendasubordinado" &&
                    <tr key={key}>
                        <td></td>
                        <td  style={{width: "85px"}}>
                            <input
                                type="number"
                                style={{textAlign: 'center', background: 'var(--mu-superficie-sutil, #eaeaea)', width: "80px"}}
                                id="OrdenarItens_TabelaOrdenarItens_CampoOrdenar"
                                ref={inputRef.current[key]}
                                onBlur={(e) => {
                                    ordenarItens(Number(e.target.value), item)
                                }}
                                value={item.OrdemItem ?? ''}
                                onChange={(e) => {
                                    ordenarItens(Number(e.target.value), item)
                                }}
                            />
                        </td>
                        <td>{item.ReferenciaProduto}</td>
                        <td>{item.Descricao}</td>
                        <td>{item.Unidade}</td>
                        <td>{item.Quantidade}</td>
                        <td>{item.PrecoProduto}</td>
                        <td>{globalMU.formatarValorNumerico(item.PrecoTotal, 3)}</td>
                    </tr>
                ))
            }
            </tbody>
        </table>
    </>
}
